import * as React from 'react';
import { BuilderElement } from '@builder.io/react';
import { ProductCard as DefaultDSProductCard, ProductCardProps as DSProductCardProps } from '@/components/shared';
import { useIsHighPriorityBlock } from '@/contexts/HighPriorityBlocksProvider';
import { useProduct } from '@/contexts/ProductProvider';
import { ProductCardComponentProps } from './register';

export interface ProductCardProps extends ProductCardComponentProps {
	readonly builderBlock: BuilderElement;
	readonly DSProductCard?: React.FC<DSProductCardProps>;
}

/**
 * CMS ProductCard component, using shared ProductCard component.
 */
export const ProductCard: React.FunctionComponent<ProductCardProps> = ({
	selectedProduct,
	builderBlock,
	DSProductCard = DefaultDSProductCard,
}) => {
	const product = useProduct(selectedProduct.id);
	const highPriority = useIsHighPriorityBlock(builderBlock.id ?? null);
	return <DSProductCard product={product ?? undefined} lazyLoading={!highPriority} />;
};
